import { toast } from "react-toastify";

export const requestSuccess = success => toast.success( success )

export const requestError = error => {
  typeof error === 'string'
    ? toast.error( error )
    : Object.values( error ).map( item => toast.error( item.replace( /_/g, ' ' ) ) )
}